// eslint-disable-next-line
export function buildVariant(modelVariant, type = '', dVal) {
  if (!modelVariant) {
    return `aggregation${type}${dVal ? `|${dVal}` : ''}`;
  }
  const ucVariant = `${modelVariant[0].toUpperCase()}${modelVariant.substring(1)}`;
  return `aggregation${ucVariant}${type}|${dVal || `aggregation${type}`}`;
}